import AzureUserInfo from "../Drawers/AzureUserInfo";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Customer from "../Drawers/Customer";
import NewInstance from "../Drawers/NewInstance";
import React, { useEffect, SyntheticEvent } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { visuallyHidden } from "@mui/utils";
import { makeStyles } from "@mui/styles";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import axios from "axios";
import { BASE_URL } from "../services/client/rest";
import MySnackbarContentWrapper from "../MySnackbarContentWrapper";
import Snackbar from "@material-ui/core/Snackbar";
import Skeleton from "@mui/material/Skeleton";
import { useQuery } from "react-query";
import {
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
} from "@mui/material";

function descendingComparator(a: any, b: any, orderBy: any) {
  var x = a[orderBy];
  var y = b[orderBy];

  if (a[orderBy] == null) {
    if (orderBy == "dateLive") {
      x = "01/01/2000";
    }
    if (orderBy == "dateBuilt") {
      x = "01/01/2000";
    }
  }
  if (b[orderBy] == null) {
    if (orderBy == "dateLive") {
      y = "01/01/2000";
    }
    if (orderBy == "dateBuilt") {
      x = "01/01/2000";
    }
  }
  if (y < x) {
    return -1;
  }
  if (y > x) {
    return 1;
  }
  return 0;
}

function getComparator(order: any, orderBy: any) {
  return order === "desc"
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function stableSort(array: any, comparator: any) {
  const stabilizedThis = array.map((el: any, index: any) => [el, index]);
  stabilizedThis.sort((a: any, b: any) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el: any) => el[0]);
}

export default function CustomerList({
  handleCustomerListCallBack,
  search,
  queryType,
}: {
  handleCustomerListCallBack: (serialNumber: number, queryType: number) => void;
  search: string;
  queryType: number;
}) {
  const classes = useStyles();
  const [order, setOrder] = React.useState<string>("asc");
  const [orderBy, setOrderBy] = React.useState("Name");
  const [selected, setSelected] = React.useState([] as any);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [currentRow, SetCurrentRow] = React.useState([] as any);
  const [showCustomer, SetShowCustomer] = React.useState(false);
  const [showNewInstance, SetShowNewInstane] = React.useState(false);
  const [serialNumber, SetSerialNumber] = React.useState(0);
  const [cutOffDealerStatus, setCutOffDealerStatus] =
    React.useState<boolean>(false);
  const [openSnackBar, setOpen] = React.useState(false);

  const [instanceChecked, setInstanceChecked] = React.useState(false);

  const [checked, setChecked] = React.useState(false);
  const [finalData, setFinalData] = React.useState([] as any);
  const [filterRes, setFilterRes] = React.useState([] as any);

  var bearer = "Bearer " + localStorage.getItem("token");
  const headers = {
    Authorization: bearer,
  };

  const handleClose = (event?: SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  function CloseCustomerDrawer(value: number = 0) {
    SetShowCustomer(value == 0 ? false : true);
  }

  function CloseNewInstanceDrawer(value: number = 0) {
    SetShowNewInstane(value == 0 ? false : true);
  }

  function AddNew() {
    SetShowNewInstane(true);
  }

  function SaveChanges(rowCustomer: any) {
    let date: Date = new Date();

    Object.keys(rowCustomer).forEach((key) => {
      let value = rowCustomer[key];
      if (key == "dateLive" && value != null) {
        const d = new Date(value);
        value = d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate();
      }
      currentRow[key] = value;
    });
    SetShowCustomer(false);

    const request = {
      dateLive: rowCustomer.dateLive,
      notes: rowCustomer.notes,
      email: rowCustomer.email,
      phone: rowCustomer.phone,
    };

    let url = "";
    if (queryType === 0) {
      url = BASE_URL + "IdealCustomers/";
    } else if (queryType === 1) {
      url = BASE_URL + "InfinityCustomers/";
    }

    axios
      .put(url + rowCustomer.serialNumber, request, {
        headers,
      })
      .then((response: any) => {
        setOpen(true);
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  const useStyles1 = makeStyles((theme: any) => ({
    root: {
      flexShrink: 0,
    },
  }));

  const handleRowClick = (currentRow: any) => {
    SetCurrentRow(currentRow);
    SetShowCustomer(true);
  };

  const displayAzureUser = (serialNumber: any, cutOffDealer: boolean) => {
    SetSerialNumber(serialNumber);
    setCutOffDealerStatus(cutOffDealer);
  };

  const headCells = [
    { id: "name", numeric: false, disablePadding: false, label: "Dealer" },
    {
      id: "serialNumber",
      numeric: true,
      disablePadding: false,
      label: "Serial#",
    },
    {
      id: "dbserver",
      numeric: false,
      disablePadding: false,
      label: "DBServer",
    },
    {
      id: "wvdserver",
      numeric: false,
      disablePadding: false,
      label: "WVDServer",
    },
    {
      id: "dateBuilt",
      numeric: false,
      disablePadding: false,
      label: "DateBuilt",
    },
    {
      id: "dateLive",
      numeric: false,
      disablePadding: false,
      label: "DateLive",
    },
    {
      id: "companyPW",
      numeric: false,
      disablePadding: false,
      label: "Password",
    },
    {
      id: "idealVersion",
      numeric: false,
      disablePadding: false,
      label: "Version#",
    },
    {
      id: "idealSystemService",
      numeric: false,
      disablePadding: false,
      label: "SysService",
    },
    {
      id: "idealConnector",
      numeric: false,
      disablePadding: false,
      label: "Connector",
    },
    { id: "Edit", numeric: false, disablePadding: false, label: "" },
  ];

  const headCellsInfinity = [
    { id: "name", numeric: false, disablePadding: false, label: "Dealer" },
    {
      id: "serialNumber",
      numeric: true,
      disablePadding: false,
      label: "Serial#",
    },
    {
      id: "dbserver",
      numeric: false,
      disablePadding: false,
      label: "DB Server",
    },
    {
      id: "wvdserver",
      numeric: false,
      disablePadding: false,
      label: "WVD Server",
    },
    {
      id: "appserver",
      numeric: false,
      disablePadding: false,
      label: "App Server",
    },
    {
      id: "dateBuilt",
      numeric: false,
      disablePadding: false,
      label: "DateBuilt",
    },
    {
      id: "dateLive",
      numeric: false,
      disablePadding: false,
      label: "DateLive",
    },
    { id: "Edit", numeric: false, disablePadding: false, label: "" },
  ];

  function EnhancedTableHead(props: any) {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler = (property: any) => (event: any) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {(queryType == 0 ? headCells : headCellsInfinity).map((headCell) => (
            <TableCell
              style={{ backgroundColor: "#F2F3F4" }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };
  function TablePaginationActions(props: any) {
    const classes = useStyles1();
    const theme: any = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event: any) => {
      setPage(0);
    };

    const handleBackButtonClick = (event: any) => {
      setPage(page - 1);
    };

    const handleNextButtonClick = (event: any) => {
      setPage(page + 1);
    };

    const handleLastPageButtonClick = (event: any) => {
      setPage(Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <div className={classes.root}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRightIcon />
          ) : (
            <KeyboardArrowLeftIcon />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeftIcon />
          ) : (
            <KeyboardArrowRightIcon />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  };

  const getCustomers = async () => {
    const jwtToken = localStorage.getItem("token");
    var bearer = "Bearer " + jwtToken;
    let url = "";
    if (queryType === 0) {
      url = BASE_URL + "IdealCustomers";
    } else if (queryType === 1) {
      url = BASE_URL + "InfinityCustomers";
    }

    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: bearer,
        },
      });
      return res.data.data;
    } catch (error) {
      console.log("Error", error);
    }
  };

  //----------------- useQuery for Data-Fetching -----------------//
  const { isFetching, data, refetch } = useQuery(
    ["GetCustomers", queryType],
    () => getCustomers(),
    {
      initialData: [],
      keepPreviousData: true,
    }
  );

  useEffect(() => {
    //* Filter Orignal Data:
    var filterData = data.filter(
      (item: any) =>
        item.cutOffDealer == checked && item.isTest == instanceChecked
    );

    //* set FilterData in state:
    setFinalData([...filterData]);
    // setFilterRes([...filterData]);
  }, [data, checked, instanceChecked]);

  const handleInstanceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInstanceChecked(event.target.checked);

    // if (event.target.checked === true) {
    //   setFinalData([...data]);
    // }

    // if (event.target.checked === false) {
    //   setFinalData([...filterRes]);
    // }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);

    // if (event.target.checked === true) {
    //   setFinalData([...data]);
    // }

    // if (event.target.checked === false) {
    //   setFinalData([...filterRes]);
    // }
  };

  const handleRequestSort = (event: any, property: any) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: any) => {};

  const handleClick = (event: any, name: any) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected: any = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event: any) => {
    setDense(event.target.checked);
  };

  const isSelected = (name: any) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - GetData().length) : 0;

  function GetData() {
    return finalData?.filter(filterRow);
  }

  function filterRow(element: any, index: any, array: any) {
    if (finalData?.length > 0) {
      var obj1 = finalData[0];
      var keys = Object.keys(obj1);
      for (let i = 0; i < keys.length; i++) {
        let cellValue = String(element[keys[i]]);
        if (cellValue.toLowerCase().includes(search.toLowerCase())) {
          return true;
        }
      }
    }
    return false;
  }

  function handleDrawerClose() {
    SetSerialNumber(0);
  }

  return (
    <>
      <Box>
        {/********** Filters Sub-header Start **********/}
        <Card
          sx={{
            padding: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FormControl component="fieldset">
            <FormGroup aria-label="position" row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={instanceChecked}
                    onChange={handleInstanceChange}
                  />
                }
                label="Show Test Instance"
                labelPlacement="start"
              />

              <FormControlLabel
                control={<Checkbox checked={checked} onChange={handleChange} />}
                label="Show Cut Off Dealers"
                labelPlacement="start"
              />
            </FormGroup>
          </FormControl>
        </Card>
      </Box>
      {/********** Filters Sub-header End **********/}

      <Box display="flex" justifyContent="center" alignItems="center">
        <Box sx={{ width: "auto", display: "table" }}>
          {isFetching ? (
            <Box sx={{ width: 1080, marginTop: "12px" }}>
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
              <Skeleton animation="wave" height={40} />
            </Box>
          ) : (
            <Paper
              sx={{
                width: "auto",
                mb: 2,
                margin: "10px 10px",
                border: "1px solid #E5E7E9",
              }}
            >
              <TableContainer>
                <Table
                  sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={GetData().length}
                  />
                  <TableBody>
                    {GetData().length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={11} align="center">
                          No Records
                        </TableCell>
                      </TableRow>
                    ) : (
                      stableSort(GetData(), getComparator(order, orderBy))
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row: any, index: any) => {
                          let classAlert1 = "";
                          if (row.systemService === "Stopped")
                            classAlert1 = classes.alert1;
                          let classAlert2 = "";
                          if (row.connector === "Stopped")
                            classAlert2 = classes.alert1;
                          const isItemSelected =
                            row.id === currentRow.id ? true : false;
                          let dateBuilt = "";
                          if (row.dateBuilt != null)
                            dateBuilt = new Date(
                              row.dateBuilt
                            ).toLocaleDateString();
                          let dateLive = "";
                          if (row.dateLive != null)
                            dateLive = new Date(
                              row.dateLive
                            ).toLocaleDateString();

                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              key={row.id}
                              selected={isItemSelected}
                              className={
                                row.cutOffDealer ? classes.CutOffDealer : ""
                              }
                            >
                              <TableCell
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                                onClick={() =>
                                  displayAzureUser(
                                    row.serialNumber,
                                    row.cutOffDealer
                                  )
                                }
                              >
                                {row.name}
                              </TableCell>
                              <TableCell align="right">
                                {row.serialNumber}
                              </TableCell>
                              <TableCell>{row.dbserver}</TableCell>
                              <TableCell>{row.wvdserver}</TableCell>
                              {queryType !== 0 && (
                                <TableCell>{row.appServer}</TableCell>
                              )}
                              <TableCell>{dateBuilt}</TableCell>
                              <TableCell>{dateLive}</TableCell>
                              {queryType === 0 && (
                                <TableCell>{row.companyPw}</TableCell>
                              )}
                              {queryType === 0 && (
                                <TableCell>{row.appVersion}</TableCell>
                              )}
                              {queryType === 0 && (
                                <TableCell className={classAlert1}>
                                  {row.systemService}
                                </TableCell>
                              )}
                              {queryType === 0 && (
                                <TableCell className={classAlert2}>
                                  {row.connector}
                                </TableCell>
                              )}
                              <TableCell
                                style={{
                                  color: "gray",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                                onClick={() => handleRowClick(row)}
                              >
                                <EditIcon style={{ fontSize: "small" }} />
                              </TableCell>
                            </TableRow>
                          );
                        })
                    )}

                    {emptyRows > 0 && (
                      <TableRow
                        style={{ height: (dense ? 33 : 53) * emptyRows }}
                      >
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[5, 10, 20, 25, 50, 100]}
                component="div"
                count={GetData().length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Paper>
          )}

          <Customer
            open={showCustomer}
            rowCustomer={currentRow}
            SaveChanges={SaveChanges}
            onClose={CloseCustomerDrawer}
          />
          {serialNumber > 0 && (
            <AzureUserInfo
              search={""}
              serialNumber={serialNumber}
              cutOffDealerStatus={cutOffDealerStatus}
              queryType={queryType}
              handleDrawerClose={handleDrawerClose}
              refetch={refetch}
            ></AzureUserInfo>
          )}

          <NewInstance
            open={showNewInstance}
            onClose={CloseNewInstanceDrawer}
            queryType={queryType}
          />

          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            open={openSnackBar}
            autoHideDuration={5000}
            onClose={handleClose}
          >
            <MySnackbarContentWrapper
              onClose={handleClose}
              variant="success"
              message="Customer Updated Successfully."
            />
          </Snackbar>
          <div style={{ position: "fixed", bottom: "10px", left: "5px" }}>
            <table>
              <tr>
                <td>
                  <Fab
                    variant="extended"
                    size="medium"
                    color="primary"
                    onClick={() => AddNew()}
                    title="Add New"
                  >
                    {<AddIcon></AddIcon>}Add New &nbsp;
                  </Fab>
                </td>
              </tr>
            </table>
          </div>
        </Box>
      </Box>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    //marginLeft: theme.spacing(2.5),
  },

  alert1: {
    backgroundColor: "#E74C3C",
    color: "white !important",
  },

  hideCell: {
    display: "none !important",
  },

  CutOffDealer: {
    background: "gray",
    "&:hover": {
      background: "gray !important",
    },
  },
}));
